import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BaseViewComponent, IconItem } from '@sb/library/base';

@Component({
    selector: 'lib-tab',
    templateUrl: './tab.component.html',
})
export class TabComponent<T> extends BaseViewComponent {

    @ContentChild('tabContent', {static: false, read: TemplateRef}) tabContent!: TemplateRef<any>;
    @Input() label: string = '';
    @Input() icon!: IconItem;
    @Input() name!: T;
    @Input() lazyLoad: boolean = true;
    @Input() hidden: boolean = false;

    private _formOverride: FormGroup<any> | undefined;
    @Input()
    set formOverride(value: FormGroup<any> | undefined) {
        this._formOverride = value;
    }

    get formOverride(): FormGroup<any> | undefined {
        return this._formOverride;
    }
}
